import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import SkillBadge from './SkillBadge';

const SkillCategory = ({ category, skills, isExpanded, onToggle }) => {
  const [hoveredSkill, setHoveredSkill] = useState(null);

  const getCategoryIcon = (categoryName) => {
    const iconMap = {
      'Frontend Technologies': 'Monitor',
      'Backend Development': 'Server',
      'Databases': 'Database',
      'DevOps & Tools': 'Settings',
      'Soft Skills': 'Users'
    };
    return iconMap[categoryName] || 'Code';
  };

  const getCategoryColor = (categoryName) => {
    const colorMap = {
      'Frontend Technologies': 'text-blue-600',
      'Backend Development': 'text-green-600',
      'Databases': 'text-purple-600',
      'DevOps & Tools': 'text-orange-600',
      'Soft Skills': 'text-pink-600'
    };
    return colorMap[categoryName] || 'text-primary';
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-sm hover:shadow-md transition-shadow duration-300">
      <button
        onClick={onToggle}
        className="w-full p-6 text-left flex items-center justify-between hover:bg-muted/50 transition-colors duration-200 rounded-t-lg"
        aria-expanded={isExpanded}
      >
        <div className="flex items-center space-x-4">
          <div className={`p-2 rounded-lg bg-muted ${getCategoryColor(category)}`}>
            <Icon name={getCategoryIcon(category)} size={24} />
          </div>
          <div>
            <h3 className="text-xl font-semibold text-text-primary">{category}</h3>
            <p className="text-sm text-text-secondary mt-1">
              {skills.length} {skills.length === 1 ? 'skill' : 'skills'}
            </p>
          </div>
        </div>
        <Icon 
          name={isExpanded ? 'ChevronUp' : 'ChevronDown'} 
          size={20} 
          className="text-text-secondary transition-transform duration-200"
        />
      </button>

      {isExpanded && (
        <div className="px-6 pb-6 animate-fade-in">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {skills.map((skill, index) => (
              <div
                key={skill.name}
                onMouseEnter={() => setHoveredSkill(skill.name)}
                onMouseLeave={() => setHoveredSkill(null)}
                className="relative"
              >
                <SkillBadge 
                  skill={skill} 
                  isHovered={hoveredSkill === skill.name}
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SkillCategory;